const apiContext = import.meta.env.VITE_APP_APIM_CONTEXT

export const SERVICES = {
  EXCEPTION_REPORT: `${apiContext}/egov-exception-report-service`,
  EXAM_REPORT: `${apiContext}/egov-exam-scheduling-service`,
  CONFIG_ENDPOINT: `${apiContext}/egov-config-service`,
  DRIVER_ENDPOINT: `${apiContext}/egov-driver-service`,
  PAYMENT_ENDPOINT: `${apiContext}/egov-payment-service`,
  FEEDBACK_ENDPOINT: `${apiContext}/egov-feedback-service`,
  COMMUNICATION_ENDPOINT: `${apiContext}/egov-communication-service`,
  VEHICLE_ENDPOINT: `${apiContext}/egov-vehicle-service`,
  TRANSACTION_ENDPOINT: `${apiContext}/egov-transaction-service`,
  IDENTITY_PROVIDER_ENDPOINT: `${apiContext}/egov-identity-provider-service`,
}

export const CONFIG_SERVICE_ENDPOINT = {
  GET_REFERENCES: `${SERVICES.CONFIG_ENDPOINT}/api/admin/references`,
  GET_PUBLIC_REFERENCES: `${SERVICES.CONFIG_ENDPOINT}/api/public/references`,
  GET_ENV_CONFIG_VALUES: `${SERVICES.CONFIG_ENDPOINT}/api/public/envConfigValues`,
  IS_RECAPTCHA_SCORE_VALID: `${SERVICES.IDENTITY_PROVIDER_ENDPOINT}/api/public/recaptcha/validate`,
  NORMALIZE_ADDRESS: `${SERVICES.CONFIG_ENDPOINT}/api/secure/address/normalize`,
}

export const IDENTITY_PROVIDER_SERVICE_ENDPOINT = {
  REFRESH_TOKEN: `${SERVICES.IDENTITY_PROVIDER_ENDPOINT}/api/public/oidc/token/refresh`,
}

export const EXCEPTION_REPORT_ENDPOINT = {
  DLDASH_RENEW_DL_UPDATE_ERRORS: `${SERVICES.EXCEPTION_REPORT}/api/admin/transactions/driver/errors/renew/update`,
  DLDASH_RENEW_EGOV_UPDATE_ERRORS: `${SERVICES.EXCEPTION_REPORT}/api/admin/transactions/driver/errors/renew/app`,
  VRDASH_RENEW_VR_UPDATE_ERRORS: `${SERVICES.EXCEPTION_REPORT}/api/admin/transactions/vehicle/errors/renew/update`,
  VRDASH_RENEW_EGOV_UPDATE_ERRORS: `${SERVICES.EXCEPTION_REPORT}/api/admin/transactions/vehicle/errors/renew/app`,
  DLDASH_TRANSACTION_DETAILS: `${SERVICES.EXCEPTION_REPORT}/api/admin/transactions/:id`,

  DLDASH_DUPLICATE_DL_UPDATE_ERRORS: `${SERVICES.EXCEPTION_REPORT}/api/admin/transactions/driver/errors/duplicate/update`,
  DLDASH_DUPLICATE_EGOV_UPDATE_ERRORS: `${SERVICES.EXCEPTION_REPORT}/api/admin/transactions/driver/errors/duplicate/app`,
  VRDASH_DUPLICATE_VR_UPDATE_ERRORS: `${SERVICES.EXCEPTION_REPORT}/api/admin/transactions/vehicle/errors/duplicate/update`,
  VRDASH_DUPLICATE_EGOV_UPDATE_ERRORS: `${SERVICES.EXCEPTION_REPORT}/api/admin/transactions/vehicle/errors/duplicate/app`,

  DLDASH_COA_DL_UPDATE_ERRORS: `${SERVICES.EXCEPTION_REPORT}/api/admin/transactions/driver/errors/coa/update`,
  DLDASH_COA_EGOV_UPDATE_ERRORS: `${SERVICES.EXCEPTION_REPORT}/api/admin/transactions/driver/errors/coa/app`,
  VRDASH_COA_VR_UPDATE_ERRORS: `${SERVICES.EXCEPTION_REPORT}/api/admin/transactions/vehicle/errors/coa/update`,
  VRDASH_COA_EGOV_UPDATE_ERRORS: `${SERVICES.EXCEPTION_REPORT}/api/admin/transactions/vehicle/errors/coa/app`,

  DLDASH_RESTORATION_DL_UPDATE_ERRORS: `${SERVICES.EXCEPTION_REPORT}/api/admin/transactions/driver/errors/restoration/update`,
  DLDASH_RESTORATION_SUCCESSFUL: `${SERVICES.EXCEPTION_REPORT}/api/admin/transactions/driver/restoration/success`,
  VRDASH_RESTORATION_VR_UPDATE_ERRORS: `${SERVICES.EXCEPTION_REPORT}/api/admin/transactions/vehicle/errors/restoration/update`,
  VRDASH_RESTORATION_EGOV_UPDATE_ERRORS: `${SERVICES.EXCEPTION_REPORT}/api/admin/transactions/vehicle/errors/restoration/app`,
  VRDASH_RESTORATION_SUCCESSFUL: `${SERVICES.EXCEPTION_REPORT}/api/admin/transactions/vehicle/restoration/success`,

  DLDASH_SUCCESSFUL: `${SERVICES.EXCEPTION_REPORT}/api/admin/transactions/driver/success`,
  VRDASH_SUCCESSFUL: `${SERVICES.EXCEPTION_REPORT}/api/admin/transactions/vehicle/success`,

  ODDASH_RENEW_DL_UPDATE_ERRORS: `${SERVICES.EXCEPTION_REPORT}/api/admin/transactions/driver/errors/organdonor/update`,
  ODDASH_RENEW_EGOV_UPDATE_ERRORS: `${SERVICES.EXCEPTION_REPORT}/api/admin/transactions/driver/errors/organdonor/app`,

  EDDASH_RENEW_EGOV_UPDATE_ERRORS: `${SERVICES.EXCEPTION_REPORT}/api/admin/transactions/errors/examschedule/app`,
  EDDASH_RENEW_DL_UPDATE_ERRORS: `${SERVICES.EXCEPTION_REPORT}/api/admin/transactions/errors/examschedule/update`,

  ODDASH_RENEW_DL_UPDATE_ERRORS_EXPORT: `${SERVICES.EXCEPTION_REPORT}/api/admin/transactions/driver/errors/organdonor/update/export`,
  ODDASH_RENEW_EGOV_UPDATE_ERRORS_EXPORT: `${SERVICES.EXCEPTION_REPORT}/api/admin/transactions/driver/errors/organdonor/app/export`,

  EDDASH_RENEW_EGOV_UPDATE_ERRORS_EXPORT: `${SERVICES.EXAM_REPORT}/api/admin/transactions/errors/examschedule/app/export`,
  EDDASH_RENEW_DL_UPDATE_ERRORS_EXPORT: `${SERVICES.EXAM_REPORT}/api/admin/transactions/errors/examschedule/update/export`,

  DLDASH_ERROR_TOTALS: `${SERVICES.EXCEPTION_REPORT}/api/admin/transactions/driver/driverlicense/count`,
  VRDASH_ERROR_TOTALS: `${SERVICES.EXCEPTION_REPORT}/api/admin/transactions/vehicle/vehicleregistration/count`,
  ODDASH_ERROR_TOTALS: `${SERVICES.EXCEPTION_REPORT}/api/admin/transactions/driver/organdonor/count`,
  ESDASH_ERROR_TOTALS: `${SERVICES.EXCEPTION_REPORT}/api/admin/transactions/examschedule/count`,

  // Vehicle Dashboard Export Endpoints
  VRDASH_ERRORS_EXPORT: (errorType, errorSubType) =>
    `${SERVICES.EXCEPTION_REPORT}/api/admin/transactions/vehicle/errors/${errorType}/${errorSubType}/export`,

  VRDASH_RESTORATION_SUCCESS_EXPORT: `${SERVICES.EXCEPTION_REPORT}/api/admin/transactions/vehicle/restoration/success/export`,

  VRDASH_SUCCESS_EXPORT: `${SERVICES.EXCEPTION_REPORT}/api/admin/transactions/vehicle/success/export`,
  // Driver License Dashboard Export Endpoints
  DLDASH_ERRORS_EXPORT: (errorType, errorSubType) =>
    `${SERVICES.EXCEPTION_REPORT}/api/admin/transactions/driver/errors/${errorType}/${errorSubType}/export`,

  DLDASH_RESTORATION_SUCCESS_EXPORT: `${SERVICES.EXCEPTION_REPORT}/api/admin/transactions/driver/restoration/success/export`,

  DLDASH_SUCCESS_EXPORT: `${SERVICES.EXCEPTION_REPORT}/api/admin/transactions/driver/success/export`,

  ADVANCED_SEARCH: `${SERVICES.EXCEPTION_REPORT}/api/admin/transactions/search`,
  ADVANCED_SEARCH_EXPORT: `${SERVICES.EXCEPTION_REPORT}/api/admin/transactions/search/export`,
}

export const EXAM_REPORT_ENDPOINT = {
  LOGIN: `${SERVICES.EXAM_REPORT}/api/public/login`,
  EXAMS: `${SERVICES.EXAM_REPORT}/api/secure/exams`,
  SITE_CENTERS: `${SERVICES.EXAM_REPORT}/api/secure/siteCenters`,
  SITE_AVAILABLE_SLOTS: `${SERVICES.EXAM_REPORT}/api/secure/availableSlots`,
  SCHEDULE_EXAM: `${SERVICES.EXAM_REPORT}/api/secure/scheduleExam`,
  RESCHEDULE_EXAM: `${SERVICES.EXAM_REPORT}/api/secure/rescheduleExam`,
  CANCEL_EXAM: `${SERVICES.EXAM_REPORT}/api/secure/cancelExam`,
}

export const PAYMENT_ENDPOINT = {
  FADASH_ERROR_TOTALS: `${SERVICES.EXCEPTION_REPORT}/api/admin/transactions/payment/count`,

  FADASH_PAYMENT_PAYMENT_UPDATE_ERRORS: `${SERVICES.EXCEPTION_REPORT}/api/admin/transactions/payment/errors/service/update`,
  FADASH_PAYMENT_EGOV_UPDATE_ERRORS: `${SERVICES.EXCEPTION_REPORT}/api/admin/transactions/payment/errors/service/app`,
  FADASH_PAYMENT_SUCCESSFUL: `${SERVICES.EXCEPTION_REPORT}/api/admin/transactions/payment/success`,

  FADASH_PROCESSOR_PAY_PROCESSOR_ERRORS: `${SERVICES.EXCEPTION_REPORT}/api/admin/transactions/payment/errors/processor`,
  FADASH_PROCESSOR_PAY_PROCESSOR_ACTIVITY: `${SERVICES.EXCEPTION_REPORT}/api/admin/transactions/payment/activity/processor`,

  FADASH_PROCESSOR_ACTIVITY_EXPORT: `${SERVICES.EXCEPTION_REPORT}/api/admin/transactions/payment/activity/processor/export`,
  FADASH_PROCESSOR_ERRORS_EXPORT: `${SERVICES.EXCEPTION_REPORT}/api/admin/transactions/payment/errors/processor/export`,
  FADASH_SERVICE_ERRORS_EXPORT: (errorSubType) =>
    `${SERVICES.EXCEPTION_REPORT}/api/admin/transactions/payment/errors/service/${errorSubType}/export`,
  FADASH_SUCCESS_EXPORT: `${SERVICES.EXCEPTION_REPORT}/api/admin/transactions/payment/success/export`,
  CHECKOUT: `${SERVICES.PAYMENT_ENDPOINT}/api/secure/payment/checkout`,
  CHECKOUT_STATUS: `${SERVICES.PAYMENT_ENDPOINT}/api/secure/payment/checkout/status`,
}

export const FEEDBACK_ENDPOINT = {
  SURVEY_LIST: `${SERVICES.FEEDBACK_ENDPOINT}/api/public/surveys`,
  SURVEY_RESPONSE: `${SERVICES.FEEDBACK_ENDPOINT}/api/public/survey-response`,
}

export const DRIVER_ENDPOINT = {
  EMERGENCY_CONTACTS: `${SERVICES.DRIVER_ENDPOINT}/api/secure/emergency/contacts`,
  CONFIG: `${SERVICES.DRIVER_ENDPOINT}/api/secure/driver/config`,
  FINAL_DOCUMENT: `${SERVICES.DRIVER_ENDPOINT}/api/secure/final/document`,
  OD_DOCUMENT: `${SERVICES.DRIVER_ENDPOINT}/api/secure/od/document`,
  FEE_CALC: `${SERVICES.DRIVER_ENDPOINT}/api/secure/feeCalculation`,
  PDPI: `${SERVICES.DRIVER_ENDPOINT}/api/secure/pdpi`,
  PDPR: `${SERVICES.DRIVER_ENDPOINT}/api/secure/pdpr`,
  FETCH_RESTORATION_LETTER: `${SERVICES.DRIVER_ENDPOINT}/api/secure/restoration/letter/content`,
}

export const DL_PUBLIC_ENDPOINT = {
  LOGIN: `${SERVICES.DRIVER_ENDPOINT}/api/public/dl/login`,
}

export const OD_PUBLIC_ENDPOINT = {
  LOGIN: `${SERVICES.DRIVER_ENDPOINT}/api/public/od/login`,
  UPDATE: `${SERVICES.DRIVER_ENDPOINT}/api/secure/od/update`,
}

export const VS_PUBLIC_ENDPOINT = {
  LOGIN_VIN: `${SERVICES.VEHICLE_ENDPOINT}/api/public/vs/login/vin`,
  LOGIN_PLATE: `${SERVICES.VEHICLE_ENDPOINT}/api/public/vs/login/plate`,
}

export const PRE_VERIFY_LOGIN_ENDPOINT = {
  PRE_VERIFY_LOGIN: `${SERVICES.DRIVER_ENDPOINT}/api/public/rid/preverify/login`,
}

export const PRE_VERIFICATION_STEP_SUBMIT = {
  PRE_VERIFY_SUBMIT: `${SERVICES.DRIVER_ENDPOINT}/api/secure/rid/preverify/submit`,
}

export const COMMUNICATION_ENDPOINT = {
  SEND_EMAIL: `${SERVICES.COMMUNICATION_ENDPOINT}/api/public/contactUs/email/send`,
}

export const VEHICLE_ENDPOINT = {
  TYPE_VANITY_PLATE: `${SERVICES.VEHICLE_ENDPOINT}/api/public/vanity/config`,
  CHECK_VANITY_PLATE: `${SERVICES.VEHICLE_ENDPOINT}/api/public/vanity/availability`,
  COA_VALIDATE: `${SERVICES.VEHICLE_ENDPOINT}/api/secure/vr/coa/validate`,
  FETCH_RESTORATION_LETTER: `${SERVICES.VEHICLE_ENDPOINT}/api/secure/restoration/letter/content`,
  FINAL_DOCUMENT: `${SERVICES.VEHICLE_ENDPOINT}/api/secure/final/document`,
}

export const TRANSACTION_ENDPOINT = {
  ADD_TO_CART: `${SERVICES.TRANSACTION_ENDPOINT}/api/secure/cart/update`,
  DELETE_FROM_CART: `${SERVICES.TRANSACTION_ENDPOINT}/api/secure/cart/delete`,
  CHECKOUT: `${SERVICES.TRANSACTION_ENDPOINT}/api/secure/cart/process`,
  DOWNLOAD_AND_PRINT: (transactionId) =>
    `${SERVICES.TRANSACTION_ENDPOINT}/api/secure/transactions/receipt?transactionID=${transactionId}`,
  GET_CART_DATA: (transactionId) => `${SERVICES.TRANSACTION_ENDPOINT}/api/secure/cart/details/${transactionId}`,
}

export const REAL_ID_OPT_IN_ENDPOINT = {
  VALIDATE: `${SERVICES.DRIVER_ENDPOINT}/api/secure/rid/optin/validate`,
}
